import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";

/**
 * AWEmpire Tube Player — embeds a live random performer video
 * Responsive: full-width on mobile, 550px max on desktop
 */
const AWTubePlayer = () => {
  const containerRef = useRef(null);
  const scriptRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Create container div
    const div = document.createElement("div");
    div.setAttribute("data-awe-container-id", "awe_player_main");
    div.style.cssText = "display:inline-block;width:100%;max-width:550px;aspect-ratio:16/9;";
    containerRef.current.appendChild(div);

    // Load the AWEmpire tube player script
    const script = document.createElement("script");
    script.src = "https://ecdwm.com/embed/tbplyrrnd/?psid=elitebionics&pstool=421_3&sexualOrientation=straight&forcedPerformers[]=&tags=&primaryColor=FF4196&labelColor=1a1a2e&campaign_id=&site=las&accessKey=32110ab8a1c2be230c0c35a959759317&ms_notrack=1&c=awe_player_main";
    script.async = true;
    scriptRef.current = script;
    document.body.appendChild(script);

    return () => {
      // Cleanup on unmount
      if (scriptRef.current && document.body.contains(scriptRef.current)) {
        document.body.removeChild(scriptRef.current);
      }
    };
  }, []);

  return (
    <Box sx={{
      width: "100%", maxWidth: { xs: "100%", md: 550 }, mx: "auto",
      display: "flex",
      flexDirection: "column", alignItems: "center",
      mb: 3, px: { xs: 0.5, md: 0 },
    }}>
      <Box sx={{
        width: "100%", borderRadius: 2, overflow: "hidden",
        border: "1px solid #333", bgcolor: "#000"
      }}>
        <div ref={containerRef} style={{ width: "100%", minHeight: 200 }} />
      </Box>
      <Typography variant="caption" sx={{ color: "#888", mt: 0.5 }}>
        🔴 Live now — click to watch free
      </Typography>
    </Box>
  );
};

export default AWTubePlayer;
